import { useState } from 'react'
import { useAppStore } from '../stores/app-store'

export function PrdViewer() {
  const { prdContent, setPrdContent, setUserPrompt, clearPrd } = useAppStore()
  const [isEditing, setIsEditing] = useState(false)

  const handleUseAsPrompt = () => {
    const prompt = `Implement the following PRD. When all requirements are met and verified, output <promise>DONE</promise>.\n\n${prdContent}`
    setUserPrompt(prompt)
  }

  if (!prdContent) return null

  return (
    <div className="card prd-viewer">
      <div className="prd-header">
        <span>Generated PRD</span>
        <div className="prd-actions">
          <button
            className="btn-small"
            onClick={() => setIsEditing(!isEditing)}
          >
            {isEditing ? 'Preview' : 'Edit'}
          </button>
          <button className="btn-small btn-primary" onClick={handleUseAsPrompt}>
            Use as Prompt
          </button>
          <button className="btn-small" onClick={clearPrd}>
            Dismiss
          </button>
        </div>
      </div>
      <div className="prd-body">
        {isEditing ? (
          <textarea
            className="prd-textarea"
            value={prdContent}
            onChange={(e) => setPrdContent(e.target.value)}
          />
        ) : (
          <pre className="prd-preview">{prdContent}</pre>
        )}
      </div>
    </div>
  )
}
